import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react';
import PropTypes from 'prop-types';
import { IoIosAdd } from 'react-icons/io';
import { createPortal } from 'react-dom';
import styles from './modal.module.scss';

const ModalStandalone = forwardRef(
  ({
    children,
    hideCloseButton = false,
    domNode = 'modal',
  }, ref) => {
    const modalRoot = document.getElementById(domNode);
    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => ({
      toggle: () => setOpen((state) => !state),
      open: () => setOpen(true),
      close: () => setOpen(false),
    }));

    function close(e) {
      e.preventDefault();
      e.stopPropagation();
      setOpen(false);
    }

    useEffect(() => {
      if (!ref) console.error('ModalStandalone components need require a ref');
    }, [ref]);

    useEffect(() => {
      if (!modalRoot) {
        console.error(`Can't find the dom element (#${domNode}) where this modal should be mount \nYou should add a div with id : "${domNode}" to public/index.html
     `);
      }
    }, [modalRoot, domNode]);

    return (
      <>
        {modalRoot && (
          <>
            {createPortal(
              <>
                {ref && open && (
                  <>
                    <div
                      className={styles['overlay-modal']}
                      onClick={(e) => close(e)}
                    />
                    <div
                      className={styles.modal}
                    >
                      {children}
                      {!hideCloseButton && (
                        <button
                          className={styles.close}
                          onClick={(e) => close(e)}
                        >
                          <IoIosAdd />
                        </button>
                      )}
                    </div>
                  </>
                )}
              </>,
              modalRoot,
            )}
          </>
        )}
      </>
    );
  },
);

ModalStandalone.propTypes = {
  domNode: PropTypes.string,
};

export default ModalStandalone;
